export const GET_CATEGORIES_PENDING = "GET_CATEGORIES_PENDING";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";

export const GET_BRANDS_PENDING = "GET_BRANDS_PENDING";
export const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS";
export const GET_BRANDS_FAIL = "GET_BRANDS_FAIL";

export const GET_HIERARCHY_CATEGORIES_PENDING =
  "GET_HIERARCHY_CATEGORIES_PENDING";
export const GET_HIERARCHY_CATEGORIES_SUCCESS =
  "GET_HIERARCHY_CATEGORIES_SUCCESS";
export const GET_HIERARCHY_CATEGORIES_FAIL = "GET_HIERARCHY_CATEGORIES_FAIL";

export const GET_GROUP_CATEGORIES_PENDING = "GET_GROUP_CATEGORIES_PENDING";
export const GET_GROUP_CATEGORIES_SUCCESS = "GET_GROUP_CATEGORIES_SUCCESS";
export const GET_GROUP_CATEGORIES_FAIL = "GET_GROUP_CATEGORIES_FAIL";

export const GET_CATEGORY_ATTRIBUTES_PENDING =
  "GET_CATEGORY_ATTRIBUTES_PENDING";
export const GET_CATEGORY_ATTRIBUTES_SUCCESS =
  "GET_CATEGORY_ATTRIBUTES_SUCCESS";
export const GET_CATEGORY_ATTRIBUTES_FAIL = "GET_CATEGORY_ATTRIBUTES_FAIL";

export const GET_EXCHANGE_RATES_PENDING = "GET_EXCHANGE_RATES_PENDING";
export const GET_EXCHANGE_RATES_SUCCESS = "GET_EXCHANGE_RATES_SUCCESS";
export const GET_EXCHANGE_RATES_FAIL = "GET_EXCHANGE_RATES_FAIL";

export const SET_CATEGORY_ID = "SET_CATEGORY_ID";
export const CLEAR_CATEGORY_ATTRIBUTES = "CLEAR_CATEGORY_ATTRIBUTES";
